module.exports = __webpack_public_path__ + "static/img2-60548cd685afc4a354d81ca0be72906d.jpg";